import Cookies from 'js-cookie';
import { isSSR } from './ssr';

export type LocalStorageFields =
  | 'ques-tokenRenewalCheckTime'
  | 'ques-usertoken'
  | 'ques-envMode'
  | 'ques-dB'
  | 'token-check'
  | 'banner';

const keys: LocalStorageFields[] = [
  'ques-tokenRenewalCheckTime',
  'ques-usertoken',
  'ques-envMode',
  'token-check',
  'banner',
];

export const ClientStorage = {
  local: {
    setItem<T>(key: LocalStorageFields, item: T) {
      if (isSSR) {
        return;
      }
      window.localStorage.setItem(key, JSON.stringify(item));
    },
    getItem<T>(key: LocalStorageFields) {
      if (isSSR) {
        return;
      }
      const dataString = window.localStorage.getItem(key);
      if (!dataString) return null;

      try {
        return JSON.parse(dataString) as T;
      } catch {
        return null;
      }
    },
    removeItem(key: LocalStorageFields) {
      if (isSSR) {
        return;
      }
      window.localStorage.removeItem(key);
    },
    clear() {
      if (isSSR) {
        return;
      }

      for (const key of keys) {
        window.localStorage.removeItem(key);
      }
    },
  },
  session: {
    setItem<T>(key: LocalStorageFields, item: T) {
      if (isSSR) {
        return;
      }
      window.sessionStorage.setItem(key, JSON.stringify(item));
    },
    getItem<T>(key: LocalStorageFields) {
      if (isSSR) {
        return;
      }
      const dataString = window.sessionStorage.getItem(key);
      if (!dataString) return null;

      try {
        return JSON.parse(dataString) as T;
      } catch {
        return null;
      }
    },
    removeItem(key: LocalStorageFields) {
      if (isSSR) {
        return;
      }
      window.sessionStorage.removeItem(key);
    },
    clear() {
      if (isSSR) {
        return;
      }
      for (const key of keys) {
        window.sessionStorage.removeItem(key);
      }
    },
  },
  cookies: {
    setItem<T>(key: LocalStorageFields, item: T, options?: Cookies.CookieAttributes) {
      Cookies.set(key, item ? JSON.stringify(item) : '', { path: '/', ...options });
    },
    getItem<T>(key: LocalStorageFields) {
      const dataString = Cookies.get(key);
      if (!dataString) return null;
      try {
        return JSON.parse(dataString) as T;
      } catch {
        return null;
      }
    },
    removeItem(key: LocalStorageFields) {
      Cookies.remove(key);
    },
    clear() {
      for (const key of keys) {
        Cookies.remove(key);
      }
    },
  },
};
